module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-11.7fbe1fea.jpg";